import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { Spinner, Text } from '@shared/ui/atoms';
import { SelectOption } from './Option';
interface SelectedValueProps {
  value: SelectOption | null;
  placeholder: string;
  placeholderIcon: ReactNode | undefined;
  isLoading: boolean;
}
const SelectedValue: FC<SelectedValueProps> = ({
  value,
  placeholder,
  placeholderIcon,
  isLoading
}) => {
  if (isLoading) {
    return <LoaderWrapper>
        <Spinner />
      </LoaderWrapper>;
  }
  if (value) {
    return <SeceltedValueWrapper>
        {value.icon && <SelectedValueIconWrapper>{value.icon}</SelectedValueIconWrapper>}
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          {value.label}
        </Text>
      </SeceltedValueWrapper>;
  }
  return <PlaceholderWrapper>
      {placeholderIcon && <PlaceholderIconWrapper>{placeholderIcon}</PlaceholderIconWrapper>}
      <Text family="MTSCompact" size="pL" weight="medium" color="tertiary">
        {placeholder}
      </Text>
    </PlaceholderWrapper>;
};
export default SelectedValue;
const LoaderWrapper = /*#__PURE__*/styled('div')({
  name: "LoaderWrapper",
  class: "l3dzpfp",
  propsAsIs: false
});
const SeceltedValueWrapper = /*#__PURE__*/styled('div')({
  name: "SeceltedValueWrapper",
  class: "s1a54gcb",
  propsAsIs: false
});
const SelectedValueIconWrapper = /*#__PURE__*/styled('div')({
  name: "SelectedValueIconWrapper",
  class: "snjhxs9",
  propsAsIs: false
});
const PlaceholderWrapper = /*#__PURE__*/styled('div')({
  name: "PlaceholderWrapper",
  class: "p9ytgbs",
  propsAsIs: false
});
const PlaceholderIconWrapper = /*#__PURE__*/styled('div')({
  name: "PlaceholderIconWrapper",
  class: "prvuiwm",
  propsAsIs: false
});

require("./SelectedValue.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SelectedValue.tsx");